//ENUM for Auth status
export const AuthStatus = {
  PENDING: `PENDING`,
  IN_PROGRESS: `IN_PROGRESS`,
  DONE: `DONE`,
  INVALID_CREDENTIAL: `INVALID_CREDENTIAL`
};